import {DialogBody, DialogFooter} from '@/components/ui/dialog-atoms/DialogAtoms'
import styled, {css} from 'styled-components'

export const StyledExportSiarDialogBody = styled(DialogBody)(
    ({theme: {spacing}}) => css`
        display: flex;
        flex-direction: column;
        gap: ${spacing * 4}px;
    `
)

export const StyledExportSiarDialogFooter = styled(DialogFooter)(
    ({theme: {spacing}}) => css`
        display: flex;
        gap: ${spacing * 2}px;
        justify-content: flex-end;
    `
)

export const StyledSiarTypeOptionsContainer = styled.div(
    ({theme: {spacing}}) => css`
        display: flex;
        flex-direction: column;
        gap: ${spacing * 2}px;
    `
)

export const StyledSiarTypeOption = styled.button<{$isSelected: boolean}>(
    ({theme: {spacing, palette, typography}, $isSelected}) => css`
        display: flex;
        align-items: center;
        justify-content: space-between;
        gap: ${spacing * 3}px;
        padding: ${spacing * 3}px ${spacing * 4}px;
        border-radius: 8px;
        border: 1.5px solid ${$isSelected ? palette.primary[600] : palette.neutral[200]};
        background: ${$isSelected ? palette.primary[25] : palette.neutral.white};
        cursor: pointer;
        text-align: left;
        transition:
            border-color 0.15s ease,
            background 0.15s ease;

        &:hover {
            border-color: ${$isSelected ? palette.primary[600] : palette.neutral[400]};
        }

        h4 {
            ${typography.textMd};
            font-weight: 600;
            color: ${palette.neutral[900]};
            margin: 0;
        }

        p {
            ${typography.textSm};
            color: ${palette.neutral[600]};
            margin: 0;
        }
    `
)

export const StyledSiarTypeOptionCheckmark = styled.span<{$isSelected: boolean}>(
    ({theme: {palette}, $isSelected}) => css`
        flex-shrink: 0;
        color: ${palette.primary[600]};
        opacity: ${$isSelected ? 1 : 0};
        transition: opacity 0.15s ease;
    `
)

export const StyledSiarTypeHint = styled.p(
    ({theme: {typography, palette}}) => css`
        ${typography.textSm};
        color: ${palette.neutral[500]};
        font-style: italic;
        margin: 0;
    `
)

export const StyledSiarTypeSelectLabel = styled.p(
    ({theme: {typography, palette}}) => css`
        ${typography.textSm};
        font-weight: 500;
        color: ${palette.neutral[700]};
        margin: 0;
    `
)
